import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioInputGroupComponent } from './radio-input-group.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    RadioInputGroupComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
  ],
  exports: [
    RadioInputGroupComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class RadioInputGroupModule { }
